exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tr-errors > td[data-v-78388f4c] {\n  border: 0 !important;\n}\n.document-exchange-rate[data-v-78388f4c]{\n    width: 140px !important;\n}\n.disabledIcon[data-v-78388f4c] {\n    pointer-events: none;\n}\n.disabledIcon > i[data-v-78388f4c] {\n    color: #E9ECEF;\n}\n", ""]);

// exports
